import { Injectable, inject } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@app/shared/services/translate.service';
import { LangChangeEvent, TranslateParser } from '@ngx-translate/core';

@Injectable()
export class CustomPaginator extends MatPaginatorIntl {
  // Services
  private translateService = inject(TranslateService);
  private translateParser = inject(TranslateParser);

  // Properties
  private rangeLabelIntl!: string;
  private noResultRangeLabelIntl!: string;

  constructor() {
    super();

    this.translateService.onLangChange.subscribe((_: LangChangeEvent) => {
      this.getTranslations();
    });

    this.getTranslations();
  }

  getTranslations() {
    this.translateService
      .get([
        'search.paginator.itemsPerPageLabel',
        'search.paginator.nextPageLabel',
        'search.paginator.previousPageLabel',
        'search.paginator.rangeLabel',
        'search.paginator.noResultRangeLabel'
      ])
      .subscribe((translation) => {
        this.itemsPerPageLabel = translation['search.paginator.itemsPerPageLabel'];
        this.nextPageLabel = translation['search.paginator.nextPageLabel'];
        this.previousPageLabel = translation['search.paginator.previousPageLabel'];
        this.rangeLabelIntl = translation['search.paginator.rangeLabel'];
        this.noResultRangeLabelIntl = translation['search.paginator.noResultRangeLabel'];
        this.changes.next();
      });
  }

  getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return this.noResultRangeLabelIntl;
    }
    length = Math.max(length, 0);
    let startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    startIndex++;
    return this.translateParser.interpolate(this.rangeLabelIntl, { startIndex, endIndex, length }) ?? '';
  };
}
